<template>
  <v-card class="elevation-12">
    <v-toolbar
      color="primary"
      dark
      flat
    >
      <v-toolbar-title>Подвердите номер телефона</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text class="p-4">
      <v-form>
        <v-text-field
          label="Код из смс"
          name="code"
          :error-messages="errors['code'] || []"
          prepend-icon="mdi-account"
          type="text"
          v-model="code"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions class="d-flex justify-space-between mb-6">
      <v-btn color="primary" @click.prevent="confirm" :loading="loading">Подтвердить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "ConfirmPhoneComponent",
    props: {
      urlSend: {
        type : String
      },
      numberPhone: {
        type: String
      }
    },
    data() {
      return {
        errors: [],
        loading: null,
        code: null
      }
    },
    methods: {
      confirm(){
        this.loading = true;
        axios.post(this.urlSend, {
          phoneNumber : this.numberPhone,
          token : this.code
        })
        .then(({data}) => {
          this.loading = false;
          this.$emit('successActivationCode');
          this.$router.push({'path' : '/'})
        })
        .catch(error => {
          this.loading = false;
          let response = error.response;
          if(response.status === 400){
            this.errors = {'code' : [response.data.message]};
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
